import gql from "graphql-tag";

const listNaikPangkatBorang = gql`
  query naikPangkatBorangList($tajuk: String) {
    naikPangkatBorangList(where: { tajuk: $tajuk }) {
      id
      kategori_permohonan
      jenis_permohonan
      lokasi_penempatan_khas
      tarikh_kriteria_mula
      tarikh_kriteria_akhir
      tarikh_permohonan_mula
      tarikh_permohonan_tamat
      tahun
      tajuk
      bil_calon
      nota_tambahan
      status
      perakuan
      medan_tambahan
      penempatan_khas
      hantar_notifikasi
    }
  }
`;

const listKenaikanPangkatMohon = gql`
  query naikPangkatMohonList($tajuk: String) {
    naikPangkatMohonList(where: { naik_pangkat: { tajuk: $tajuk } }) {
      id
      naik_pangkat {
        jenis_permohonan
        kategori_permohonan
        tajuk
        tahun
        status
        tarikh_permohonan_mula
        tarikh_permohonan_tamat
        penempatan_khas
      }
      status_permohonan
      status_keputusan
      tarikh_kuatkuasa_keputusan
      lampiran_surat_siaran
      lampiran_surat_siaran_meta
    }
  }
`;


export const listKenaikanPangkatMohon2 = gql`
  query myListMohonNaikPangkat($tajuk: String) {
    myListMohonNaikPangkat(where: { naik_pangkat: { tajuk: $tajuk } }) {
      id
      naik_pangkat {
        jenis_permohonan
        kategori_permohonan
        tajuk
        tahun
        status
        tarikh_permohonan_mula
        tarikh_permohonan_tamat
        penempatan_khas
      }
      status_permohonan
      status_keputusan
      tarikh_kuatkuasa_keputusan
      lampiran_surat_siaran
      lampiran_surat_siaran_meta
    }
  }
`;

const viewNaikPangkatMohon = gql`
  query naikPangkatMohonView($input: Float!) {
    naikPangkatMohonView(input: $input) {
      id
      naik_pangkat {
        id
        jenis_permohonan
        kategori_permohonan
        tajuk
        tahun
        status
        markah_lnpt_tahun_mula
        markah_lnpt_tahun_akhir
        tarikh_permohonan_mula
        tarikh_permohonan_tamat
        penempatan_khas
      }
      tarikh_masa_hantar
      status_permohonan
      emel
      no_telefon_bimbit
      tempat_tinggal_alamat
      tempat_tinggal_poskod
      tempat_tinggal_negeri {
        nama_negeri
      }
      status_perkahwinan {
        kod_sts_kahwin
        nama_sts_kahwin
      }
      waris_nama
      waris_hubungan
      waris_no_kad_pengenalan
      waris_no_telefon_bimbit
      waris_pekerjaan
      waris_majikan
      waris_majikan_alamat
      waris_majikan_poskod
      waris_majikan_negeri {
        nama_negeri
      }
      bilangan_anak
      skim_perkhidmatan {
        nama_skim
      }
      gred
      gaji_pokok
      tarikh_lantikan_sekarang
      tarikh_sah_sekarang
      tarikh_naik_pangkat_terakhir
      tarikh_memangku
      tarikh_persaraan
      kementerian {
        nama_kementerian
      }
      agensi {
        nama_agensi
      }
      bertugas_alamat
      bertugas_bandar_kod
      bertugas_poskod
      bertugas_negeri {
        nama_negeri
      }
      no_telefon_pejabat
      no_faks_pejabat
      emel_ketua_jabatan
      nama_sijil_badan_ikhtisas
      jenis_ahli_mia
      no_ahli_mia
      tarikh_ahli_mia
      badan_ikhtisas
      penempatan_khas_lokasi
      penempatan_khas_negeri {
        nama_negeri
      }
      penempatan_khas_poskod
      penempatan_pertama_negeri {
        nama_negeri
      }
      penempatan_pertama
      penempatan_kedua_negeri {
        nama_negeri
      }
      penempatan_kedua
      status_pinjaman_pendidikan
      status_istihar_harta
      tarikh_istihar_harta
      perakuan
      data_medan_tambahan
      no_rujukan_keputusan
      tarikh_kuatkuasa_keputusan
      status_keputusan
      jawatan
      pegawai {
        jawatan
        kementerian_name
        agensi_name
      }
      jabatan_bertugas_semasa
    }
  }
`;

const listNaikPangkatBorangPublic = gql`
  query naikPangkatBorangListPublic {
    naikPangkatBorangListPublic {
      id
      kategori_permohonan
      jenis_permohonan
      lokasi_penempatan_khas
      tarikh_kriteria_mula
      tarikh_kriteria_akhir
      tarikh_permohonan_mula
      tarikh_permohonan_tamat
      tahun
      tajuk
      bil_calon
      nota_tambahan
      status
      perakuan
      medan_tambahan
      penempatan_khas
      hantar_notifikasi
    }
  }
`;

export {
  listKenaikanPangkatMohon,
  listNaikPangkatBorang,
  viewNaikPangkatMohon,
  listNaikPangkatBorangPublic,
};
